import { type Common } from '../common.js';
import { ORGANIZATION_ID_HEADER_KEY } from './constants.js';
import {
  type ResourceGatewayCreateIngestionJobResponse,
  type ResourceGatewayGetIngestionJobResponse,
} from '../models/resourceGateway/ingestionJob.js';

export interface ResourceGatewayCreateIngestionJobOptions {
  organizationId: string;
  records: Record<string, unknown>[];
  transformationDefinition: unknown;
  sourceFilename?: string;
}

export class API {
  common: Common;
  baseEndpoint = '/resource-gateway/integration-gateway/ingestion/jobs';

  constructor(common: Common) {
    this.common = common;
  }

  async create(
    options: ResourceGatewayCreateIngestionJobOptions
  ): Promise<ResourceGatewayCreateIngestionJobResponse> {
    const { organizationId, records, transformationDefinition, sourceFilename } = options;
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.fetchJsonWithCustomHeaders({
      url,
      method: 'POST',
      body: { records, transformationDefinition, sourceFilename },
      headers: { [ORGANIZATION_ID_HEADER_KEY]: organizationId },
    });
  }

  async get(jobId: string): Promise<ResourceGatewayGetIngestionJobResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${jobId}`);
    return await this.common.getJSON(url);
  }
}
